/* MJ collection cards (Oct 2026): tell Shopify's customer events when a grid card is seen and clicked.
   Events: mj_card_view and mj_card_click, with { card, name, slot, collection }.
   A custom pixel (Settings > Customer events) can forward them to GA4 as view_promotion / select_promotion.
   v20 (16 Oct 2026): also keeps the phone title count ("25 beds") in step with the filters, and marks the
   page while the phone filter drawer is open (body.mj-filter-open) so the dimmed background covers the
   Filter / Sort bar and the WhatsApp bubble steps aside. */
(function () {
  'use strict';
  var seen = {};

  function publish(name, card) {
    var grid = document.getElementById('product-grid');
    var data = {
      card: card.getAttribute('data-mj-card') || '',
      name: card.getAttribute('data-mj-card-name') || '',
      slot: Number(card.getAttribute('data-mj-slot') || 0),
      collection: (grid && grid.getAttribute('data-collection')) || ''
    };
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (error) { /* analytics must never break the page */ }
  }

  function watch() {
    var cards = document.querySelectorAll('#product-grid .mj-ccard');
    if (!cards.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          var key = entry.target.getAttribute('data-mj-card') + ':' + entry.target.getAttribute('data-mj-slot');
          if (seen[key]) return;
          seen[key] = true;
          publish('mj_card_view', entry.target);
          io.unobserve(entry.target);
        });
      }, { threshold: [0.5] });
      cards.forEach(function (card) { io.observe(card); });
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('#product-grid .mj-ccard [data-mj-card-link]');
    if (link) publish('mj_card_click', link.closest('.mj-ccard'));
  });

  // v20: the phone title count follows the sidebar count ("1 of 25 products" -> "1 bed")
  function syncHeadCount() {
    var head = document.querySelector('.mj-chead__count');
    var src = document.getElementById('pro-count');
    if (!head || !src) return;
    var one = head.getAttribute('data-one');
    var many = head.getAttribute('data-many');
    var m = (src.textContent || '').replace(/,/g, '').match(/\d+/);
    if (!one || !many || !m) return;
    var n = parseInt(m[0], 10);
    var text = n + ' ' + (n === 1 ? one : many);
    if (head.textContent !== text) head.textContent = text;
  }

  // v20: body.mj-filter-open while the phone filter drawer is open
  function watchDrawer() {
    var drawer = document.querySelector('.shop-sidebar-inner .filter-sidebar');
    if (!drawer || !('MutationObserver' in window)) return;
    var sync = function () { document.body.classList.toggle('mj-filter-open', drawer.classList.contains('active')); };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function start() {
    watch();
    watchDrawer();
    syncHeadCount();
    var count = document.getElementById('pro-count');
    if (count && 'MutationObserver' in window) {
      new MutationObserver(syncHeadCount).observe(count, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // The grid is re-rendered when filters change
  var container = document.getElementById('ProductGridContainer');
  if (container && 'MutationObserver' in window) {
    new MutationObserver(function () { window.setTimeout(function () { watch(); syncHeadCount(); }, 150); }).observe(container, { childList: true });
  }
})();
